<template>
    <Head title="Ringkasan Patroli"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <div class="p-fluid formgrid grid">
                            <div class="field col-12 md:col-3">
                                <AutoComplete
                                    forceSelection
                                    placeholder="Nama Karyawan"
                                    id="dd"
                                    :dropdown="true"
                                    v-model="selectedEmployee"
                                    :suggestions="autoFilteredValue.employee"
                                    @complete="searchEmployee($event)"
                                    field="name"
                                />
                            </div>
                            <div class="field col-12 md:col-3">
                                <AutoComplete
                                    forceSelection
                                    placeholder="Unit Penempatan"
                                    id="up"
                                    :dropdown="true"
                                    v-model="selectedUnit"
                                    :suggestions="autoFilteredValue.unit"
                                    @complete="searchUnit($event)"
                                    field="name"
                                />
                            </div>
                            <div class="field col-12 md:col-3">
                                <Calendar v-model="startDate" :showIcon="true" dateFormat="dd-mm-yy" placeholder="Dari Tanggal">
                                </Calendar>
                            </div>
                            <div class="field col-12 md:col-3">
                                <Calendar v-model="endDate" :showIcon="true" dateFormat="dd-mm-yy" :showButtonBar="true" placeholder="Sampai Tanggal">
                                </Calendar>
                            </div>
                            <div class="field col-12 md:col-3">
                                <Button
                                        label="Cari"
                                        icon="pi pi-zoom"
                                        class="p-button-primary ml-2"
                                        @click="changeFilters"
                                    />
                            </div>
                        </div>
                    </template>
                    <template v-slot:end>
                        <Button
                                label="Export Reports"
                                icon="pi pi-print"
                                class="p-button-success"
                                :disabled="isExporting"
                                @click="exportDetailToPdf"
                            />
                    </template>
                </Toolbar>

                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    :selectAll="selectAll"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Ringkasan Patroli</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                        headerStyle="width: 3rem"
                    ></Column>
                    <Column
                        field="name"
                        header="Patroli Poin"
                        :sortable="true"
                        headerStyle="width:20%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            {{ slotProps.data.name }}
                        </template>
                    </Column>
                    <Column
                        field="name"
                        header="Penempatan"
                        :sortable="true"
                        headerStyle="width:20%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            {{ slotProps.data.placement }}
                        </template>
                    </Column>
                    <Column
                        field="user"
                        header="Anggota"
                        :sortable="true"
                        headerStyle="width:40%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">user</span>
                            {{ slotProps.data.user }}
                        </template>
                    </Column>
                    <Column
                        field="created_at"
                        header="Patroli Pada"
                        :sortable="true"
                        headerStyle="width:30%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.created_at }}
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import axios from "axios";
import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import DatatableService from "../../Services/DatatableService";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        AutoComplete,
        Button,
        Calendar,
        InputText,
        Toolbar,
        Toast,
        DataTable,
        Column,
    },
    data() {
        return {
            searchFilter: "",
            filters: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            lazyParams: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            loading: true,
            totalRecords: 0,
            selectAll: false,
            selectedEmployee: null,
            autoFilteredValue: {
                employee: [],
                unit: []
            },
            startDate: null,
            endDate: null,
            models: [],
            selectedUnit: null,
            isExporting: false,
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.loadLazyData();
    },
    methods: {
        searchEmployee(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    axios
                        .get(`${this.$page.props.appUrl}api/employees`)
                        .then((data) => {
                            this.autoFilteredValue = {
                                ... this.autoFilteredValue,
                                employee: data.data.data
                            };
                        });
                } else {
                    let filterValue = event.query.toLowerCase();
                    axios
                        .get(
                            `${this.$page.props.appUrl}api/employees?search=${filterValue}`
                        )
                        .then((data) => {
                            this.autoFilteredValue = {
                                ... this.autoFilteredValue,
                                employee: data.data.data
                            };
                        });
                }
            }, 250);
        },
        searchUnit(event){
            setTimeout(() => {
                if(!event.query.trim().length) {
                    axios
                        .get(`${this.$page.props.appUrl}api/placement-units?limit=10`)
                        .then((data) => {
                            this.autoFilteredValue = {
                                ... this.autoFilteredValue,
                                unit: data.data
                            };
                        })
                    return;
                }

                let filterValue = event.query.toLowerCase();
                axios
                    .get(
                        `${this.$page.props.appUrl}api/placement-units?search=${filterValue}&limit=10`
                    )
                    .then((data) => {
                        this.autoFilteredValue = {
                            ... this.autoFilteredValue,
                            unit: data.data
                        };
                    });
            }, 250)
        },
        loadLazyData() {
            this.loading = true;

            this.lazyParams.filters = this.filters;
            this.datatableService
                .getData(`${this.$page.props.appUrl}api/admin/patrol-checkins/datatable`, this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter(event) {
            this.loadLazyData();
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
        changeFilters(){
            this.filters = {
                global: {value: this.selectedEmployee ? this.selectedEmployee.id : null, field: 'user_id'},
                date: {fromDate: this.startDate, toDate: this.endDate},
                placement: this.selectedUnit ? this.selectedUnit.id : null,
            };
            this.loadLazyData();
        },
        exportDetailToPdf(){
            this.isExporting = true;

            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/admin/patrol-checkins/exportPdf`,
                responseType: 'blob',
                params: this.lazyParams,
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Employee-Patrols.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../../assets/demo/badges.scss";
</style>
